import moment from 'moment';
import { memo } from 'react';

const CRMLeadCommentMessage = ({
  data = {},
  sameToNext,
  setOpen,
  setImages,
}) => {
  const photo = data?.message?.includes('[photo]')
    ? data?.message?.replace(/^\[photo\]\s*/, '')
    : '';

  const onClickImage = () => {
    setImages({
      imgs: [photo, photo],
      titles: ['Telegram bot image', 'Telegram bot image'],
      captions: ['Bot image', 'Bot image'],
    });
    setOpen(true);
  };

  return (
    <div
      className='flex gap-2'
      style={{
        marginBottom: sameToNext ? '2px' : '4px',
        justifyContent: data?.is_client == 1 ? 'left' : 'right',
        flexDirection: data?.is_client == 1 ? '' : 'row-reverse',
      }}
    >
      {sameToNext ? (
        <div className='lead-comment-icon text-base leading-4 w-[42px] h-[42px] min-w-[42px] min-h-[42px] flex items-center justify-center' />
      ) : (
        <div className='lead-comment-icon self-end text-base leading-4 border-2 border-base-color text-base-color rounded-full w-[42px] h-[42px] min-w-[42px] min-h-[42px] flex items-center justify-center'>
          <i className='bi bi-person text-xl'></i>
        </div>
      )}

      <div
        className={`lead-comment-wrapper flex items-center p-4 max-w-[75%] min-w-56 rounded-xl w-fit relative`}
        style={{
          background: data?.is_client == 1 ? '#405368' : '#57b2e0',
        }}
      >
        {!sameToNext &&
          (data?.is_client == 1 ? (
            <div className='rounded-r-xl w-4 absolute -left-2 bottom-0 h-[20px] bg-[#405368]'>
              <div className='h-full w-2 rounded-br-[100px] bg-[#F2F3F7] z-10'></div>
            </div>
          ) : (
            <div className='rounded-l-xl min-w-4 w-4 absolute -right-2 bottom-0 h-[20px] bg-[#57b2e0]'>
              <div className='h-full min-w-2 w-2 ml-2 rounded-bl-[100px] bg-[#F2F3F7] z-10'></div>
            </div>
          ))}
        <div className='lead-comment-details w-full text-white'>
          {photo ? (
            <div className='h-auto w-36'>
              <img
                className='w-full h-full object-contain cursor-pointer'
                src={photo}
                onClick={onClickImage}
                alt='message-image'
              />
            </div>
          ) : (
            <div>{data?.message}</div>
          )}
          <div className='text-[12px] text-gray-300 absolute bottom-1 right-1'>
            {moment(data?.created_at).format('DD.MM.YYYY HH:mm')}
          </div>
        </div>
      </div>
    </div>
  );
};
export default memo(CRMLeadCommentMessage);
